module.exports = __webpack_public_path__ + "img/list47.41bb2121.jpeg";